import * as React from "react";
import { forwardRef } from "react";
const SvgIcChevronLight24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9697 11.001L15.6894 14.8408L17 13.5301L12.4697 9.00009L11.409 9.00009L6.87868 13.5301L8.18932 14.8408L11.9697 11.001Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcChevronLight24);
export { ForwardRef as ReactComponent };
